import React from 'react';
import clsx from 'clsx';

import Img from '@common/Image';

import * as styles from '@styles/modules/common.module.scss';

const ColouredDropShadow = ({ image, colour, direction }) => {
  return (
    <Img
      loading='eager'
      image={image.gatsbyImageData}
      file={image.file}
      alt={image.description}
      className={clsx({
        [`${styles.imgLeft} ${colour ? styles[colour] : null}`]:direction === 'Left',
        [`${styles.imgRight} ${colour ? styles[colour] : null}`]:direction === 'Right',
      })}
    />
  )
}

export default ColouredDropShadow
